var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0525 2.69401C4.56464 1.38373 6.49916 0.663721 8.5 0.666512C13.1025 0.666512 16.8333 4.39735 16.8333 8.99985C16.8333 10.7798 16.275 12.4298 15.325 13.7832L12.6667 8.99985H15.1667C15.1668 7.69287 14.7827 6.41468 14.0622 5.32423C13.3417 4.23377 12.3166 3.37914 11.1143 2.86662C9.91203 2.35409 8.5856 2.20626 7.29997 2.44153C6.01434 2.67679 4.82622 3.28476 3.88334 4.18985L3.0525 2.69401ZM13.9475 15.3057C12.4354 16.616 10.5008 17.336 8.5 17.3332C3.89751 17.3332 0.166672 13.6023 0.166672 8.99985C0.166672 7.21985 0.725005 5.56985 1.675 4.21651L4.33334 8.99985H1.83334C1.83323 10.3068 2.2173 11.585 2.93779 12.6755C3.65827 13.7659 4.68339 14.6205 5.88569 15.1331C7.08798 15.6456 8.41441 15.7934 9.70004 15.5582C10.9857 15.3229 12.1738 14.7149 13.1167 13.8098L13.9475 15.3057Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.2bf6242494153cadee1ca138488575d6.svg";
export { ForwardRef as ReactComponent };